import { handleActions } from 'redux-actions'
import { Action } from 'redux'

import { initialState, ContractState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils'
import { Err, ErrSuccess } from '../../../types/form'

const actionsNames = [
  'checkCif',
  'createCif',
  'fetchContract',
  'fetchPreContract',
  'printPreContract',
  'saveContract',
  'saveContractSignStatus',
  'savePreContract',
  'savePreContractStatus',
  'signContract',
  'startPrintPreContract',
]

interface Actions {
  checkCif: any
  createCif: any
  fetchContract: (callbacks: ErrSuccess) => Action
  fetchPreContract: (callbacks: Err) => Action
  printPreContract: (callbacks: ErrSuccess) => Action
  saveContract: any
  saveContractSignStatus: any
  savePreContract: any
  savePreContractStatus: any
  signContract: (callbacks: ErrSuccess) => Action
  startPrintPreContract: (callbacks: ErrSuccess) => Action
}

export const actions: Actions = prepareActions(actionsNames, 'contract') as Actions

export default handleActions<ContractState, Payload>(
  {
    [actions.savePreContract]: (state: ContractState, action): ContractState =>
      state.set('preContractPdf', action.payload),
    [actions.savePreContractStatus]: (state: ContractState, action): ContractState =>
      state.set('preContractStatus', action.payload),
    [actions.saveContract]: (state: ContractState, action): ContractState =>
      state.set('contractPdf', action.payload),
    [actions.saveContractSignStatus]: (state: ContractState, action): ContractState =>
      state.set('contractSignStatus', action.payload),
  },
  initialState
)
